const Switch = ({ actived, onClick }) => {
  return (
    <div
      className={`w-11 h-6 rounded-full flex items-center relative transition-all duration-300 overflow-hidden cursor-pointer ${
        actived ? "bg-primary" : "bg-[#E5E7EB]"
      }`}
      onClick={onClick}
    >
      <div
        className={`w-[22px] h-[18px] rounded-full bg-white transition-all duration-300 ${
          actived ? "translate-x-[18px]" : "translate-x-[5px]"
        }`}
      ></div>
    </div>
  );
};

export default Switch;
